import { useEffect, useState } from "react";

import CreatableSelect from "react-select/creatable";
import Select from "react-select";

export default function EditModals({ users, tour, additionalCosts }) {
  const [selectedUsers, setSelectedUsers] = useState({ value: -1, label: "" });
  const [selectedEscort, setSelectedEscort] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [tourDiscount, setTourDiscount] = useState(0);
  const [tourPrice, setTourPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [SAC, setSAC] = useState([
    {
      id: -1,
      price: 0,
      discount: 0,
      totalPrice: 0,
    },
  ]);
  const [AC, setAC] = useState([]);

  function selectBuyer(value) {
    if (value.__isNew__) {
      value = { value: -1, label: value.label };
    }
    setSelectedUsers(value);
  }

  function selectEscorts(value) {
    value = value.map((val) => {
      if (val.__isNew__) {
        return { value: -1, label: val.label };
      }
      return val;
    });
    setSelectedEscort(value);
  }

  function selectACHandler(value, index) {
    let x,
      flag = false;
    if (value === null) {
      x = SAC.filter((val, ind) => index != ind);
    } else {
      let ac = additionalCosts.find((val) => val.id == value.value);
      if (typeof ac === "undefined") return;
      x = SAC.map((val, ind) => {
        if (ind == index) {
          flag = val.id == -1;
          val.id = ac.id;
          val.price = ac.price;
          val.totalPrice = ac.price;
        }
        return val;
      });
    }
    if ((flag && x.length != AC.length) || x.length == 0) {
      x.push({ id: -1, price: 0, discount: 0, totalPrice: 0 });
    }
    setSAC(x);
  }

  function save() {}

  useEffect(() => {
    let x = (tour.price - tourDiscount) * (selectedEscort.length + 1);
    setTourPrice(x > 0 ? x : 0);
  }, [tour, tourDiscount, selectedEscort]);

  useEffect(() => {
    let x = SAC.reduce((total, value) => {
      return total + value.totalPrice;
    }, 0);
    setTotalPrice(tourPrice + x);
  }, [SAC, tourPrice]);

  useEffect(() => {
    setTourDiscount(tour.discount);
    if (additionalCosts?.length > 0) {
      setAC(
        additionalCosts.map((value) => {
          return {
            value: value.id,
            label: value.title,
          };
        })
      );
    }
    setUserOptions(
      users.map((value) => {
        return {
          value: value.id,
          label: `${value.fname} ${value.lname} - ${value.mobile}`,
        };
      })
    );
  }, []);

  return (
    <>
      <div
        class="modal fade text-black"
        id="edit-tour"
        tabindex="-1"
        aria-labelledby="Label"
        aria-hidden="true"
      >
        <div class="edit-tour-modal modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="Label">
                ویرایش رزرو تور
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="row align-items-center  my-3">
                <label className="col-12 col-lg-2">نام خریدار :</label>
                <div className="col-12 col-lg-9">
                  <CreatableSelect
                    onChange={selectBuyer}
                    options={userOptions.filter((value) => {
                      return (
                        selectedEscort.findIndex(
                          (val) => val.value == value.value
                        ) == -1
                      );
                    })}
                  />
                </div>
              </div>
              <div className="row align-items-center  my-3">
                <div className="col-12 col-lg-2">نام همراهان :</div>
                <div className="col-12 col-lg-9">
                  <CreatableSelect
                    isMulti
                    closeMenuOnSelect={false}
                    onChange={selectEscorts}
                    options={userOptions.filter(
                      (value) => selectedUsers.value != value.value
                    )}
                  />
                </div>
              </div>
              <div className="d-flex flex-column">
                <div className="tables">
                  <div className="item col-12 col-lg-6">
                    <div className="title">عنوان تور :</div>
                    <div className="description">
                      <input
                        type="text"
                        className="the-input form-control"
                        value={tour.title}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="item col-12 col-lg-6">
                    <div className="title">قیمت تور :</div>
                    <div className="description">
                      <input
                        type="number"
                        className="the-input form-control"
                        value={tour.price}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="item col-12 col-lg-6">
                    <div className="title">تخفیف :</div>
                    <div className="description">
                      <input
                        type="number"
                        className="the-input form-control"
                        min={0}
                        max={tour.price}
                        value={tourDiscount}
                        onChange={(e) => setTourDiscount(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="item col-12 col-lg-6">
                    <div className="title">تعداد :</div>
                    <div className="description">
                      <input
                        type="number"
                        className="the-input form-control"
                        disabled
                        value={selectedEscort.length}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <div className="my-3 col-12 col-md-6 col-lg-4">
                    <div className="input-group">
                      <span className="input-group-text">جمع کل:</span>
                      <input
                        type="number"
                        className="form-control"
                        disabled
                        value={tourPrice}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {AC.length > 0 ? (
                <>
                  <hr style={{ lineHeight: 3 }} />
                  {/* هزینه های اضافی */}
                  <div className="text-center">
                    <div className="fw-bold">هزینه های اضافی</div>
                  </div>

                  {SAC.map((value, index) => (
                    <div className={`tables`}>
                      <div
                        className={`item col-12 ${
                          value.id != -1 ? "col-lg-6" : ""
                        }`}
                      >
                        <div className="title">عنوان تور</div>
                        <div className="description">
                          <Select
                            isClearable
                            isRtl
                            options={AC.filter((v) => {
                              if (
                                typeof SAC.find((val) => val.id == v.value) ===
                                "undefined"
                              )
                                return true;
                              return false;
                            })}
                            onChange={(val) => selectACHandler(val, index)}
                          />
                        </div>
                      </div>
                      {value.id != -1 ? (
                        <>
                          <div className="item col-12 col-lg-6">
                            <div className="title">قیمت واحد</div>
                            <div className="description">
                              <input
                                type="number"
                                className="form-control the-input"
                                disabled
                                value={value.price}
                              />
                            </div>
                          </div>
                          <div className="item col-12 col-lg-6">
                            <div className="title"> تخفیف </div>
                            <div className="description">
                              <input
                                type="number"
                                className="form-control the-input"
                                disabled={value.id == -1}
                                min={0}
                                max={value.price}
                                value={value.discount}
                                onChange={(e) => {
                                  setSAC(
                                    SAC.map((val, ind) => {
                                      if (ind == index) {
                                        let x =
                                          val.price * selectEscorts.length + 1;
                                        x -= e.target.value;
                                        return {
                                          ...val,
                                          discount: e.target.value,
                                          totalPrice: x > 0 ? x : 0,
                                        };
                                      }
                                      return val;
                                    })
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="item col-12 col-lg-6">
                            <div className="title"> تعداد </div>
                            <div className="description">
                              <input
                                type="number"
                                className="form-control the-input"
                                disabled
                                value={selectEscorts.length + 1}
                              />
                            </div>
                          </div>
                          <div className="item col-12">
                            <div className="title"> مجموع </div>
                            <div className="description">
                              <input
                                type="number"
                                className="form-control the-input"
                                disabled
                                value={value.totalPrice}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                  <div className="d-flex justify-content-end mt-3">
                    <div className="col-12 col-md-6 col-xl-3">
                      <div className="input-group ">
                        <div className="input-group-text"> جمع کل :</div>
                        <input
                          type="number"
                          className="col-12 col-md-8 form-control"
                          disabled
                          value={totalPrice}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
              <button
                type="button"
                class="btn btn-primary"
                disabled={selectedUsers == null}
                onClick={save}
              >
                ثبت ویرایش
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
